export const environment = {
  envName: 'DEV',
  production: false,
  apiUrl: 'https://ckk-new.riseplus.tech/api',
  // apiUrl: 'https://uat.ckk-new.riseplus.tech/api',
  version: 'v7.0.0',
};
